import gql from 'graphql-tag'

export * from './provingGround.generated'

export const GET_PROVING_GROUND = gql`
  query ProvingGround($id: String!) {
    provingGround(id: $id) {
      _id
      title
      countryCode
      abbr
      specialNote
      inactive
    }
  }
`

export const PROVING_GROUND_DROPDOWN_QUERY = gql`
  query ProvingGroundDropdown {
    provingGrounds(filter: { inactive: { EQ: false } }) {
      _id
      title
      abbr
      specialNote
    }
  }
`
